// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Dashboard',
    items: [
      { title: 'salaries', path: PATH_DASHBOARD.general.salaries, icon: ICONS.analytics },
      {
        title: 'Career Guidance',
        path: PATH_DASHBOARD.general.sessions,
        icon: ICONS.analytics,
        children: [
          { title: 'Career guides', path: PATH_DASHBOARD.sessions.careerGuides }
        ]
      },
      {
        title: 'Tuitions',
        path: PATH_DASHBOARD.general.tuitions,
        icon: ICONS.ecommerce,
        children: [
          { title: 'Tutors', path: PATH_DASHBOARD.tuitions.tutors },
          { title: 'Classes', path: PATH_DASHBOARD.tuitions.classes },
          // { title: 'Subjects', path: PATH_DASHBOARD.tuitions.subjects }

        ]
      }
    ]
  }
];

export default sidebarConfig;
